import _classCallCheck from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { Circle } from "./Circle";
import { Range } from "./Range";
export var Rectangle = /*#__PURE__*/function (_Range) {
  _inherits(Rectangle, _Range);

  var _super = _createSuper(Rectangle);

  function Rectangle(x, y, width, height) {
    var _this;

    _classCallCheck(this, Rectangle);

    _this = _super.call(this, x, y);
    _this.size = {
      height: height,
      width: width
    };
    return _this;
  }

  _createClass(Rectangle, [{
    key: "contains",
    value: function contains(point) {
      var w = this.size.width,
          h = this.size.height,
          pos = this.position;
      return point.x >= pos.x && point.x <= pos.x + w && point.y >= pos.y && point.y <= pos.y + h;
    }
  }, {
    key: "intersects",
    value: function intersects(range) {
      if (range instanceof Circle) {
        range.intersects(this);
      }

      var w = this.size.width,
          h = this.size.height,
          pos1 = this.position,
          pos2 = range.position,
          size2 = range instanceof Rectangle ? range.size : {
        width: 0,
        height: 0
      },
          w2 = size2.width,
          h2 = size2.height;
      return pos2.x < pos1.x + w && pos2.x + w2 > pos1.x && pos2.y < pos1.y + h && pos2.y + h2 > pos1.y;
    }
  }]);

  return Rectangle;
}(Range);